
const WHITEGLOVEROUTENAME = '11111-WHTGLV';

export const isWhiteGloveRoutes = (routeName) => {
  return routeName === WHITEGLOVEROUTENAME;
};

export const handleWhiteGloveProMove = ({shipments =[], routeName = "", snackbar = () => {}}) => {

  const isWhiteGloveRoute = isWhiteGloveRoutes(routeName);
  const isMoveIntoWhiteGloveRoute =
    isWhiteGloveRoute && shipments.some((shipment) => !shipment.isWhiteGloveDelivery);
  const isMoveOutOfWhiteGloveRoute =
    !isWhiteGloveRoute && shipments.some((shipment) => shipment.isWhiteGloveDelivery);

  if (isMoveIntoWhiteGloveRoute) {
    snackbar?.('Shipments cannot be moved into the white glove route.', { variant: 'error' });
    return true;
  }
  if (isMoveOutOfWhiteGloveRoute) {
    snackbar?.('Shipments cannot be moved out of the white glove route.', { variant: 'error' });
    return true;
  }
  return false;
};

export const handleWhiteGloveRouteNameChange = ({ routeName = '', snackbar = () => {} }) => {
  const isWhiteGloveRoute = isWhiteGloveRoutes(routeName);
  if (isWhiteGloveRoute) {
    snackbar?.('Cannot change the name of the white glove route.', { variant: 'error' });
    return true;
  }
  return false;
};